import { VCombobox } from 'vuetify/lib/components/VCombobox';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VCombobox,{attrs:{"clearable":"","label":_vm.displayLabel,"items":_vm.choices,"item-text":"displayValue","item-value":"value"},on:{"change":_vm.onChange},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }